import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { User, ActivationRequest } from 'src/app/domains/users/models';
import { UsersService } from 'src/app/domains/users/services';
import { CompanyService } from 'src/app/domains/companies/services';

import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-set-user-password-popup',
  templateUrl: './set-user-password-popup.component.html',
  styleUrls: ['./set-user-password-popup.component.scss']
})
export class SetUserPasswordPopupComponent implements OnInit {
  @Output() onSetUserPassword: EventEmitter<string | void> = new EventEmitter();
  public user: User;
  public companyId: number;
  public form: UntypedFormGroup;
  public loading = false;

  constructor(
    private usersService: UsersService,
    private companyService: CompanyService,
    private notification: NotificationService,
    private modal: NgbActiveModal
  ) { }

  ngOnInit() {}

  submit(p: string) {
    if (this.user.enabled) {
      this.updatePassword(p);
    } else {
      this.activateUser(p)
    }
  }

  public updatePassword(pwd: string) {
    this.loading = true;
    this.companyService
      .updateUserPassword(
        this.companyId,
        this.user.userId,
        pwd)
      .subscribe(
        r => {
          this.loading = false;
          this.onSetUserPassword.emit('company.user.password-popup.updated');
          this.close();
        }, () => {
          this.loading = false;
        }
      );
  }

  public activateUser(pwd: string) {
    const r: ActivationRequest = {
      email: this.user.email,
      newPassword1: pwd,
      newPassword2: pwd
    };
    this.loading = true;
    this.usersService.activateUser(r)
      .subscribe(
        r => {
          this.loading = false;
          this.onSetUserPassword.emit('company.user.activate.success');
          this.close();
        }, () => {
          this.loading = false;
        }
      );
  }


  public close() {
    this.modal.close();
  }

}
